module.exports = __webpack_public_path__ + "img/slider_contact3.87d3226d.jpg";